document.addEventListener("DOMContentLoaded", () => {
  const scrollBtn = document.querySelector(".scroll-progress");

  if (!scrollBtn) return;

  const updateProgress = () => {
    const scrollTop = window.scrollY;
    const docHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    scrollBtn.style.setProperty("--progress", `${progress}%`);

    if (scrollTop > 300) {
      scrollBtn.classList.add("active");
    } else {
      scrollBtn.classList.remove("active");
    }
  };

  window.addEventListener("scroll", updateProgress);
  updateProgress();

  scrollBtn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});
